import siteClosingReportDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const siteClosingReportReducer = siteClosingReportDispatcher(initialState, {
  [siteClosingReportDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [siteClosingReportDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [siteClosingReportDispatcher.resetData]: (state, _) => ({
    ...initialState
  })
});

export default siteClosingReportReducer;
